import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { Lock, LockOpen } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { useAtom } from "jotai";

export function CollapseSwitch() {
	const [themeConfiguration, setThemeConfiguration] = useAtom(themeAtom);
	const { isCollapse, isSidebarHover } = themeConfiguration;

	return (
		<Box
			py={1}
			px={1}
			width="100%"
			display="flex"
			justifyContent={!isCollapse || isSidebarHover ? "flex-end" : "center"}
		>
			<IconButton
				onClick={() =>
					setThemeConfiguration({
						...themeConfiguration,
						isCollapse: !isCollapse,
					})
				}
				size="small"
			>
				{!isCollapse ? (
					<Lock fontSize="small" />
				) : (
					<LockOpen fontSize="small" />
				)}
			</IconButton>
		</Box>
	);
}
